import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';


import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';

/* Other imports */
import IntlPropType from '../../intl';
import { dialParticipant } from '../../lib/actions/room';
import { logEvent, Event } from '../../lib/analytics';
import { isPhoneNumber, isSipUri } from '../../lib/utils';
import ClosableDialog from '../ClosableDialog';

import style from './style';


const messages = defineMessages({
  ok: { id: 'call' },
  phone: { id: 'phoneNumber' },
  title: { id: 'dialToMeetingDialogTitle' },
  content: { id: 'dialToMeetingDialogContent' },
  phoneError: { id: 'dialToMeetingValidatioError' },
});


class DialToMeetingDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: '',
      invalidPhoneNumber: false,
    };
  }

  onInvite = () => {
    this.props.dispatch(dialParticipant(this.state.phoneNumber));
    this.props.onClose();
    logEvent(Event.INVITE_BY_PHONE);
  }

  isPhoneNumberOrURIInvalid = (number) => {
    const matches = isPhoneNumber(number) || isSipUri(number);
    return !matches;
  }

  handlePhoneNumberChange = (ev) => {
    const value = ev.target.value;
    this.setState({
      phoneNumber: value,
      invalidPhoneNumber: this.isPhoneNumberOrURIInvalid(value),
    });
  }

  handleKeyUp = (ev) => {
    if ((ev.key === 'Enter') && (this.state.phoneNumber) &&
      !this.isPhoneNumberOrURIInvalid(this.state.phoneNumber)) {
      this.onInvite();
    }
  }

  render() {
    const classes = this.props.classes;
    const inputLabel = this.props.intl.formatMessage(messages.phone);
    const invalidMessage = this.props.intl.formatMessage(messages.phoneError);

    return (
      <ClosableDialog
        open={this.props.open}
        onClose={this.props.onClose}
        title={this.props.intl.formatMessage(messages.title)}
      >
        <DialogContent className={classes.content}>
          <DialogContentText className={classes.text}>
            {this.props.intl.formatMessage(messages.content)}
          </DialogContentText>
          <div className={classes.container}>
            <FormControl error={this.state.invalidPhoneNumber}>
              <InputLabel>{inputLabel}</InputLabel>
              <Input
                autoFocus
                value={this.state.phoneNumber}
                onChange={this.handlePhoneNumberChange}
                onKeyUp={this.handleKeyUp}
              />
              {this.state.invalidPhoneNumber ?
                <FormHelperText>{invalidMessage}</FormHelperText>
                : null}
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disabled={this.state.invalidPhoneNumber === true || this.state.phoneNumber === ""}
            onClick={this.onInvite} color="primary"
          >
            {this.props.intl.formatMessage(messages.ok)}
          </Button>
        </DialogActions>
      </ClosableDialog>
    );
  }
}


DialToMeetingDialog.propTypes = {
  intl: IntlPropType.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};


export default withStyles(style)(injectIntl(connect()(DialToMeetingDialog)));
